import React, { createContext, useContext, useState, useEffect } from "react";
import { encryptText, storeTokens } from "../utility/Common";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [userLevelId, setUserLevelId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isBirthday, setIsBirthday] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem("ac-service-user");
    const userLevelId = localStorage.getItem("userLevelId");
    if (savedUser && userLevelId) {
      setUser(JSON.parse(savedUser));
      setUserLevelId(userLevelId);
      setIsAuthenticated(true);
    }
    setIsBirthday(sessionStorage.getItem("isBirthday") === "true");

    setLoading(false);
  }, []);

  const login = async (userData) => {
    var user = {
      UserId: userData.User.UserId,
      FirstName: userData.User.FirstName,
      LastName: userData.User.LastName,
      MobileNo: userData.User.MobileNo,
      UserLevelId: userData.User.UserLevelId,
      Status: userData.User.Status,
    }
    setUser(user);

    const encrypted = await encryptText(userData.User.UserLevelId);
    setUserLevelId(encrypted);
    setIsAuthenticated(true);

    storeTokens(userData.AccessToken, userData.RefreshToken);

    localStorage.setItem("userLevelId", encrypted);
    localStorage.setItem("ac-service-user", JSON.stringify(user));

    const birthday = userData.User.IsBirthday === true;
    setIsBirthday(birthday);
    sessionStorage.setItem("isBirthday", birthday ? "true" : "false");
  };

  const logout = () => {
    setUser(null);
    setUserLevelId(null);
    setIsAuthenticated(false);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userLevelId");
    localStorage.removeItem("ac-service-user");
    sessionStorage.removeItem("popupBannerShown");
    sessionStorage.removeItem("isBirthday");
    setIsBirthday(false);
  };

  const value = {
    isAuthenticated,
    user,
    userLevelId,
    login,
    logout,
    loading,
    isBirthday,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};


